import { ModalDetalhePedidoProvider } from "../../ModalDetalhePedidoContext";
import Listagem from "./Listagem";

export default function ListarTodos() {
    return (
        <ModalDetalhePedidoProvider>
            <Listagem />
        </ModalDetalhePedidoProvider>
    )
}